export default "__VITE_ASSET__CD5cxjD2__"